/* DROP theme: product page (options, add to bag, full screen viewer, sticky bar, recently viewed) */
(() => {
  const DROP = window.DROP; const { $, $$ } = DROP;

  const init = root => {
    if (!root || root._init) return; root._init = 1;
    let P = {}, H = {};
    try { P = JSON.parse($('[data-pjson]', root).textContent); H = JSON.parse($('[data-hints]', root).textContent); } catch (e) { }
    const info = (() => { try { return JSON.parse(root.dataset.productInfo); } catch (e) { return {}; } })();
    const groups = $$('.sizes[data-opt]', root);
    const add = $('#add', root), hint = $('#hint', root);
    const sel = groups.map(() => null);
    const variants = P.variants || [];
    const fmt = c => `${window.DROP_CFG.currency || 'EGP'} ${(c % 100 ? (c / 100).toFixed(2) : c / 100).toLocaleString('en-US')}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

    /* a value is unavailable when no in stock variant has it with the other choices made so far */
    const syncOptions = () => {
      groups.forEach((g, gi) => $$('button', g).forEach(b => {
        const ok = variants.some(v => v.available && v.options[gi] === b.dataset.v && sel.every((s, si) => si === gi || s === null || v.options[si] === s));
        b.disabled = !ok; b.setAttribute('aria-disabled', !ok);
        if (!ok && b.getAttribute('aria-pressed') === 'true') { b.setAttribute('aria-pressed', 'false'); sel[gi] = null; }
      }));
    };
    const current = () => (sel.every(s => s !== null) ? variants.find(v => sel.every((s, i) => v.options[i] === s)) : null);
    const showPrice = v => {
      if (!v) return; const pr = $('#pprice', root);
      pr.innerHTML = v.compare_at_price > v.price ? `<span class="sale">${fmt(v.price)}</span><s>${fmt(v.compare_at_price)}</s>` : fmt(v.price);
      const sp = $('#satc-p', root); if (sp) sp.textContent = fmt(v.price);
    };
    groups.forEach((g, gi) => g.addEventListener('click', e => {
      const b = e.target.closest('button'); if (!b || b.disabled) return;
      $$('button', g).forEach(x => x.setAttribute('aria-pressed', x === b)); sel[gi] = b.dataset.v;
      const lab = g.previousElementSibling?.querySelector('[data-sel]'); if (lab) lab.textContent = '· ' + b.dataset.l;
      if (hint) hint.textContent = '';
      syncOptions(); const v = current(); showPrice(v);
      if (v) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
    }));
    syncOptions();
    /* preselect: the variant in the address, or the size the customer filtered by in the shop */
    const urlV = new URLSearchParams(location.search).get('variant');
    const pre = urlV && variants.find(v => String(v.id) === urlV && v.available);
    if (pre) groups.forEach((g, gi) => $$('button', g).find(b => b.dataset.v === pre.options[gi])?.click());
    else if (groups.length) {
      try { const pref = sessionStorage.getItem('drop-size'); const b = pref && $$('button:not([disabled])', groups[0]).find(x => x.dataset.l === pref); if (b) b.click(); } catch (e) { }
      groups.forEach(g => { const live = $$('button:not([disabled])', g); if (live.length === 1 && g.dataset.opt !== '0') live[0].click(); });
    }

    let addT;
    const doAdd = async () => {
      let id = add?.dataset.variant;
      if (!id) {
        const v = current();
        if (!v) { if (hint) hint.textContent = H.select || 'Select a size first'; groups[sel.findIndex(s => s === null)]?.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
        id = v.id;
      }
      if (add.dataset.busy) return; add.dataset.busy = 1;
      const size = sel.map((s, i) => $$('button', groups[i]).find(b => b.dataset.v === s)?.dataset.l).filter(Boolean).join(' · ');
      const reset = () => { clearTimeout(addT); add.textContent = H.add || 'Add to bag'; };
      add.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="m5 12 4.5 4.5L19 7"/></svg> ${DROP.esc(H.added || 'Added')}`;
      clearTimeout(addT); addT = setTimeout(reset, 1800);
      try { const ok = await DROP.cart.add(id, 1, { ...info, size }); if (!ok) reset(); } finally { delete add.dataset.busy; }
    };
    add?.addEventListener('click', doAdd);

    /* gallery dots on mobile */
    const gal = $('#gal', root);
    gal?.addEventListener('scroll', () => { const i = Math.round(gal.scrollLeft / gal.clientWidth); $$('#dots i', root).forEach((d, k) => d.classList.toggle('on', k === i)); }, { passive: true });

    /* full screen viewer: swipe, tap or click to zoom, the zoomed photo follows the mouse */
    const lb = $('#lb', root), track = $('#lb-track', root), lbn = $('#lb-n', root), hintEl = $('#lb-hint', root);
    if (lb) {
      document.body.appendChild(lb);
      const prevB = $('.lb__prev', lb), nextB = $('.lb__next', lb);
      const n = $$('.lb__slide', track).length, last = n - 1;
      const fine = matchMedia('(hover:hover) and (pointer:fine)').matches;
      const ZOOM = 2.5, clamp = v => Math.min(1, Math.max(0, v));
      const cur = () => Math.round(track.scrollLeft / track.clientWidth);
      const lbHint = z => (hintEl.textContent = z ? (fine ? H.zoom_fine : H.zoom_touch) : fine ? H.click : n > 1 ? H.swipe : H.tap);
      const setN = () => { const c = cur(); lbn.textContent = `${c + 1} / ${n}`; if (prevB) { prevB.disabled = c <= 0; nextB.disabled = c >= last; } };
      const panTo = (s, fx, fy) => s.scrollTo((s.scrollWidth - s.clientWidth) * clamp(fx), (s.scrollHeight - s.clientHeight) * clamp(fy));
      const shown = s => { const img = $('img', s), r = img.naturalWidth / img.naturalHeight || 1, bw = s.clientWidth, bh = s.clientHeight, w = Math.min(bw, bh * r), h = w / r, b = s.getBoundingClientRect(); return { w, h, left: b.left + (bw - w) / 2, top: b.top + (bh - h) / 2 }; };
      const zoomIn = (s, fx, fy) => { const img = $('img', s), d = shown(s); s.classList.add('z'); img.style.width = Math.round(d.w * ZOOM) + 'px'; img.style.height = Math.round(d.h * ZOOM) + 'px'; track.classList.add('locked'); panTo(s, fx, fy); lbHint(true); };
      const zoomOut = s => { s.classList.remove('z'); const img = $('img', s); img.style.width = img.style.height = ''; s.scrollTo(0, 0); track.classList.remove('locked'); lbHint(false); };
      const unzoom = () => $$('.lb__slide.z', track).forEach(zoomOut);
      const go = i => { unzoom(); track.scrollTo({ left: Math.max(0, Math.min(last, i)) * track.clientWidth, behavior: 'smooth' }); };
      let back = null;
      const openLb = i => {
        $$('img[data-src]', track).forEach(im => { im.src = im.dataset.src; im.removeAttribute('data-src'); });
        back = document.activeElement; lb.hidden = false; document.body.style.overflow = 'hidden';
        track.scrollLeft = i * track.clientWidth; setN(); lbHint(false);
        $('#lb-x', lb).focus({ preventScroll: true });
      };
      const closeLb = () => { unzoom(); lb.hidden = true; document.body.style.overflow = ''; back?.focus?.({ preventScroll: true }); };
      $$('[data-lb]', root).forEach(b => (b.onclick = () => openLb(+b.dataset.lb)));
      $('#lb-x', lb).onclick = closeLb;
      prevB?.addEventListener('click', () => go(cur() - 1));
      nextB?.addEventListener('click', () => go(cur() + 1));
      track.addEventListener('scroll', setN, { passive: true });
      $$('.lb__slide', track).forEach(s => {
        s.addEventListener('click', e => { if (s.classList.contains('z')) return zoomOut(s); const d = shown(s); zoomIn(s, (e.clientX - d.left) / d.w, (e.clientY - d.top) / d.h); });
        if (fine) s.addEventListener('mousemove', e => { if (!s.classList.contains('z')) return; const r = s.getBoundingClientRect(); panTo(s, (e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height); });
      });
      addEventListener('keydown', e => { if (lb.hidden) return; if (e.key === 'Escape') closeLb(); if (e.key === 'ArrowRight') go(cur() + 1); if (e.key === 'ArrowLeft') go(cur() - 1); });
    }

    /* sticky add to bag bar */
    const satc = $('#satc', root);
    if (satc && add) {
      document.body.appendChild(satc);
      $('#satc-btn', satc).onclick = () => {
        if (!add.dataset.variant && !current()) { scrollTo({ top: 0, behavior: 'smooth' }); setTimeout(() => hint && (hint.textContent = H.select), 400); return; }
        doAdd();
      };
      const onS = () => { const on = add.getBoundingClientRect().bottom < 0 && (!lb || lb.hidden); satc.classList.toggle('on', on); document.body.classList.toggle('satc-on', on); };
      addEventListener('scroll', onS, { passive: true }); onS();
    }

    /* remember this piece for Recently viewed */
    try { const rec = JSON.parse(localStorage.getItem('drop-recent') || '[]'); localStorage.setItem('drop-recent', JSON.stringify([root.dataset.handle, ...rec.filter(h => h !== root.dataset.handle)].slice(0, 12))); } catch (e) { }
  };

  /* recently viewed: cards are rendered by Shopify for each saved product */
  const recent = sec => {
    if (!sec || sec._init) return; sec._init = 1;
    let rec = []; try { rec = JSON.parse(localStorage.getItem('drop-recent') || '[]'); } catch (e) { }
    const me = sec.dataset.current; rec = rec.filter(h => h && h !== me).slice(0, 10);
    if (!rec.length) return;
    const root = (window.DROP_CFG.root || '/').replace(/\/$/, '');
    const run = async () => {
      const rail = $('.rail', sec);
      const htmls = await Promise.all(rec.map(h => fetch(DROP.withParam(`${root}/products/${encodeURIComponent(h)}`, 'section_id', 'product-card')).then(r => (r.ok ? r.text() : '')).catch(() => '')));
      htmls.forEach(html => { const c = $('.card', DROP.parse(html)); if (c) rail.appendChild(c); });
      if (rail.children.length) { sec.hidden = false; DROP.motion(sec); }
    };
    const go = () => ('requestIdleCallback' in window ? requestIdleCallback(run, { timeout: 3000 }) : setTimeout(run, 1500));
    document.readyState === 'complete' ? go() : addEventListener('load', go, { once: true });
  };

  const boot = (r = document) => { $$('[data-product]', r).forEach(init); $$('[data-recent]', r).forEach(recent); };
  boot();
  document.addEventListener('drop:section', e => boot(e.detail));
})();
